import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getBannerProject } from '../detailApartment.api';
import { getQueryString } from '../../../utils/params';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';
import { useParams } from 'react-router-dom';

function BannerApartmentComponent() {
  const { language } = useParams();
  const [banner, setBanner] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { id } = useParams();
  useEffect(() => {
    showLoader();
    getBannerProject(getQueryString({ language, projectId: id })).then(res => {
      setBanner(res?.data);
      hideLoader();
    });
    //eslint-disable-next-line
  }, []);

  const handleBanner = () => {
    return (
      <>
        {banner && banner.bannerUrl !== null ? (
          <div
            className="aparment-banner"
            style={{
              backgroundImage: `url(${process.env.REACT_APP_ISN_IMAGE_URL}${banner.bannerUrl})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              backgroundSize: 'cover',
            }}
          >
            <div className="d-flex flex-column align-items-center justify-content-center aparment-banner__info">
              <div className="aparment-banner__info--title text-truncate-banner-name text-tra detail-project-font-size-24">
                {banner.cityName}
              </div>
              <div className="aparment-banner__info--title text-truncate-banner-name">{banner.name}</div>
              <div className="aparment-banner__info--address text-truncate-banner-name pt-3">{banner.address}</div>
            </div>
            <div className="aparment-banner__color-overlay"></div>
          </div>
        ) : (
          ''
        )}
        {loader}
      </>
    );
  };

  return <div id="detailApartmentBanner">{handleBanner()}</div>;
}

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BannerApartmentComponent);
